<template>
    <div
        class="cc-home"
    >
        <div v-show="!hideHeader" class="cc-header">
            <div class="cc-header-left">
                <img src="../../assets/logo.png" alt="">
            </div>
            <div class="cc-header-right">
                <div class="help-icon">
                    <span @click="gotoHelpDoc">
                        <veui-icon ref="helpRef" name="question-circle"/>
                    </span>
                    <veui-tooltip
                        position="bottom"
                        target="helpRef"
                        ui="reverse"
                        :hide-delay="100"
                        overlay-class="help-overlay"
                    >
                        帮助文档
                    </veui-tooltip>
                </div>
                <feedback/>
                <div class="header-line"></div>
                <veui-button
                    ui="xl"
                    class="cc-header-login"
                    @click="handleShowLoginModal()"
                >登录</veui-button>
            </div>
        </div>
        <div class="side-anchor">
            <div
                class="anchor-item"
                :class="{
                    'selected': currentAnchor === 0,
                }"
                @click="handleClickAnchor(0)"
            >
                <div class="circle"></div>
                <div v-if="currentAnchor === 0" class="loop"></div>
            </div>
            <div
                v-for="(item, index) in navList"
                :key="index + 1"
                class="anchor-item"
                :class="{
                    'selected': currentAnchor === index + 1,
                }"
                @click="handleClickAnchor(index + 1, item)"
            >
                <div class="circle"></div>
                <div v-if="currentAnchor === index + 1" class="loop"></div>
            </div>
        </div>
        <div id="cc-home-login-container"></div>
        <div class="cc-sub-bg">
            <div class="random-block block1"></div>
            <div class="random-block block2"></div>
        </div>
        <div class="cc-login-list">
            <section
                ref="topContent"
                class="cc-top-container"
                data-index="0"
            >
                <div class="bg-video">
                    <div
                        ref="homeBannerBgDom"
                        class="home-banner bg"
                    >
                        <video
                            class="normal-video"
                            src="https://qiaojiang.bj.bcebos.com/fe/static/images/home/large-video-bg-new.mp4"
                            autoplay
                            muted
                            loop
                            preload="true"
                            playsInline="true"
                            webkit-playsinline="true"
                            x-webkit-airplay="true"
                            x5-playsinline="true"
                            x5-video-player-type="h5"
                            x5-video-orientation="portraint"
                            t7-video-player-type="inline"
                        ></video>
                    </div>
                    <div
                        ref="homeCubeDom"
                        class="home-banner full bg-video-cube"
                    >
                        <video
                            class="large-video"
                            src="https://qiaojiang.bj.bcebos.com/fe/static/images/home/large-video-full-new.mp4"
                            autoplay
                            muted
                            loop
                            preload="true"
                            playsInline="true"
                            webkit-playsinline="true"
                            x-webkit-airplay="true"
                            x5-playsinline="true"
                            x5-video-player-type="h5"
                            x5-video-orientation="portraint"
                            t7-video-player-type="inline"
                        ></video>
                    </div>
                </div>
                <div class="cc-main-container">
                    <div class="cc-main-content">
                        <div class="cc-main-content-left">
                            <div class="main-logo">AIGC 赋能营销创意</div>
                            <div class="main-title">
                                <!-- <p class="main-title-line1">AIGC赋能</p>
                                <p class="main-title-line2">营销创意新纪元</p> -->
                                <p class="main-title-line1">擎舵能力焕新</p>
                                <p class="main-title-line2">全面接入DeepSeek</p>
                            </div>
                            <div class="main-desc">
                                汇聚行业顶级AI技术，生成焕新<br>
                                提供精准、创新、原生、多元的多模态广告创意服务
                            </div>
                        </div>
                        <div class="cc-nav-container">
                            <div
                                v-for="(item, index) in navList" :key="index"
                                class="cc-nav-item-container"
                                @click="handleNavClick(index + 1, item)"
                                @mouseenter="handleMouseToggleIcon($event, item, true)"
                                @mouseleave="handleMouseToggleIcon($event, item)"
                            >
                                <div
                                    class="cc-nav-item"
                                    :style="{width: `${item.width}px`}"
                                >
                                    <span
                                        class="cc-nav-icon icon-dom"
                                        :style="{backgroundImage: `url(${item.icon})`}"
                                    ></span>
                                    <div>
                                        <div class="cc-nav-title">{{ item.title }}</div>
                                        <div class="cc-nav-desc">{{ item.desc }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section
                v-for="(item, index) in contentList"
                :ref="`content-${index}`"
                :key="index"
                :data-index="index + 1"
                class="cc-sub-container"
                :class="{
                    'has-footer': index === contentList.length - 1,
                }"
                @scroll="handleSectionScroll($event, index === contentList.length - 1)"
            >
                <div
                    class="cc-content-container"
                >
                    <div class="cc-content-left">
                        <div
                            class="cc-content-text"
                            @mouseenter="handleMouseToggleIcon($event, item, true)"
                            @mouseleave="handleMouseToggleIcon($event, item)"
                        >
                            <div
                                class="cc-content-icon"
                            >
                                <div
                                    class="cc-content-icon-content icon-dom"
                                    :style="{
                                        backgroundImage: `url(${item.icon})`,
                                    }"
                                ></div>
                            </div>
                            <div class="cc-content-title">{{ item.title }}</div>
                            <div class="cc-content-desc">{{ item.desc }}</div>
                            <div
                                v-if="item.buttonList"
                                class="cc-content-button-list"
                            >
                                <div
                                    v-for="(buttonItem, index) in item.buttonList"
                                    :key="index + buttonItem.text"
                                    class="cc-nav-button active"
                                    @click="handleShowLoginModal(buttonItem)"
                                >
                                    <font>{{ buttonItem.text }}</font>
                                </div>
                            </div>
                            <div
                                v-else-if="item.routeName"
                                class="cc-nav-button active single"
                                @click="handleShowLoginModal(item)"
                            >立即体验</div>
                            <div
                                v-else
                                class="cc-nav-button disabled"
                            >敬请期待</div>
                        </div>
                    </div>
                    <div class="cc-content-right cc-video-container">
                        <video
                            :ref="`video-${index}`"
                            :data-index="index + 1"
                            controlsList="nodownload"
                            :src="item.video"
                            playsInline="true"
                            webkit-playsinline="true"
                            x-webkit-airplay="true"
                            x5-playsinline="true"
                            x5-video-player-type="h5"
                            x5-video-orientation="portraint"
                            class="cc-video"
                            preload="auto"
                            autoplay
                            muted
                            loop
                        ></video>
                    </div>
                </div>
                <cc-footer v-if="index === contentList.length - 1"/>
            </section>
        </div>
        <div ref="mouseDom" class="mouse-page-toggle">
            <img src="./assets/icon-mouse.png">
            <span>下滑查看</span>
        </div>
    </div>
</template>

<script>
/* globals ucCommonLogin */
import {Button, Icon, Tooltip} from 'veui';
import {navList, contentList} from './config/indexV2.js';
import LinkFooter from './components/LinkFooter.vue';
import passportMixinV2 from '@/mixins/passportMixinV2';
import Feedback from '@/component/Feedback';
import 'veui-theme-dls-icons/user-circle';
import 'veui-theme-dls-icons/chevron-down';

import {get as getCookie} from '@/lib/cookie';
import {APP_ID} from '@/common/config';

export default {
    name: 'login',
    inject: ['$toast', 'alsLog'],
    mixins: [passportMixinV2],
    components: {
        'veui-button': Button,
        'veui-icon': Icon,
        'veui-tooltip': Tooltip,
        'cc-footer': LinkFooter,
        Feedback
    },
    data() {
        return {
            navList,
            contentList,
            currentAnchor: 0,
            contentRefs: [],
            hideHeader: false,
            loading: true
        };
    },
    created() {
        // 打开登录页的时候，尝试获取一下登录信息，如果已经登录通过了的，则自动跳到登录后的首页
        const CPID = getCookie(`CPID_${APP_ID}`) || '';
        const CPTK = getCookie(`CPTK_${APP_ID}`) || '';
        const hairuo = {
            allowNotLogin: true,
            userid: CPID,
            optid: CPID,
            token: CPTK
        };
        this.$store.dispatch('getUserInfo', hairuo).then(data => {
            // 已经登录的则直接跳到登录状态之后的首页
            if (data?.accountInfo) {
                this.$router.push({
                    path: `/user/${CPID}/index`
                });
            }
        }).catch(err => {
        });
    },
    mounted() {
        this.alsLog({
            f1: 'loginPagePv',
            f2: 'show',
            f5: this.$route.name,
            f11: 'v2'
        });

        // 视频需要在可视区才开始播放，监听活动区域变化
        this.observeContentScroll();
    },
    watch: {
        currentAnchor(to) {
            // 切到最后一屏，不显示鼠标动态
            if (parseInt(to, 10) === this.contentList.length) {
                this.$refs.mouseDom.style.display = 'none';
            }
            else {
                this.$refs.mouseDom.style.display = 'flex';
            }
            if (to > 0) {
                this.hideLoginAndShowCube();
            }
            this.hideHeader = false;
        }
    },
    methods: {
        // 点击按钮切换内容
        handleClickAnchor(index, item = {}) {
            this.currentAnchor = index;
            let refDom = this.contentRefs[index];
            refDom.scrollIntoView();
            if (index === this.contentRefs.length - 1) {
                refDom.scrollTo({top: 0});
            }
        },
        // 点击登录按钮，打开登录的浮窗，魔方隐藏
        handleShowLoginModal(item = null) {
            this.currentAnchor = 0;
            this.contentRefs[0].scrollIntoView();
            ucCommonLogin.show();
            this.showLoginAndHideCube();

            this.alsLog({
                f1: `${item ? 'detailButton' : 'loginButton'}`,
                f2: 'click',
                f11: `v2_button_${item ? item?.text : '登录'}`
            });
        },
        // 点击快捷跳转的菜单
        handleNavClick(index, item) {
            this.alsLog({
                f1: 'quickButton',
                f2: 'click',
                f11: `v2_quick_${item?.title}`
            });
            this.handleClickAnchor(index);
        },
        // 鼠标滑过和离开图标，切换静态与gif，gif需要每次重新加载，要不然不会重新播放一次
        handleMouseToggleIcon(e, item, isGif = false) {
            let opeDom = e.target;
            let targetDom = opeDom.querySelector('.icon-dom');
            if (!targetDom) {
                return;
            }
            if (isGif) {
                const time = new Date().getTime();
                // 每次重新拉取gif才能重新播放，但是拉取有瞬间白屏，所以设置两个，用icon做白屏占位
                targetDom.style.backgroundImage = `url(${item.gif}?v=${time}),url(${item.icon})`;
                // gif拉取成功播放完后，需要清除第二个图，防止错位重叠、效果异常
                setTimeout(() => {
                    targetDom.style.backgroundImage = `url(${item.gif}?v=${time})`;
                }, 200);
            }
            else {
                targetDom.style.backgroundImage = `url(${item.icon})`;
            }
        },
        // 最后一屏滑动时，把头部隐藏，避免重叠
        handleSectionScroll(e, isLast = false) {
            const scrollTop = e.target.scrollTop;
            if (isLast && scrollTop > 70) {
                this.hideHeader = true;
            }
            else {
                this.hideHeader = false;
            }
        },
        gotoHelpDoc() {
            const {protocol, host} = window.location;
            const prefix = `${protocol}//${host}`;
            const firstDoc = '信息流广告标题';
            const url = `${prefix}/helpDoc/${firstDoc}`;
            this.alsLog({
                f1: 'helpDoc',
                f2: 'click',
                f5: this.$route.name,
                f15: this.$route?.path
            });
            window.open(url, '_blank', 'noreferrer');
        },
        // 视频需要在可视区才开始播放，监听活动区域变化
        observeContentScroll() {
            const refNames = Object.keys(this.$refs);
            let videos = [];
            let contents = [];
            contents.push(this.$refs.topContent);
            refNames.forEach(item => {
                if (item.startsWith('video-')) {
                    videos.push(this.$refs[item][0]);
                }
                if (item.startsWith('content-')) {
                    contents.push(this.$refs[item][0]);
                }
            });
            this.contentRefs = contents;

            // 监听视频元素进入可视区开始播放
            const optionsVideo = {
                root: null,
                rootMargin: '0px',
                threshold: 0.5 // 设置可见性阈值，表示当视频元素至少50%可见时触发回调
            };
            const callbackVideo = (entries, observer) => {
                entries.forEach((entry, index) => {
                    if (entry.isIntersecting) {
                        const video = entry.target;
                        video.play();
                    }
                    else {
                        const video = entry.target;
                        video.pause();
                    }
                });
            };
            const observerVideo = new IntersectionObserver(callbackVideo, optionsVideo);
            videos.forEach(video => {
                observerVideo.observe(video);
            });

            // 监听内容元素进入可视区，触发进入的动画
            const optionsContent = {
                root: null,
                rootMargin: '0px',
                threshold: 0.2
            };
            const callbackContent = (entries, observer) => {
                entries.forEach((entry, index) => {
                    if (entry.isIntersecting) {
                        const content = entry.target;
                        let index = parseInt(content.getAttribute('data-index'), 10);
                        if (index > this.currentAnchor) {
                            content.classList.add('slide-up');
                        }
                        else {
                            content.classList.add('slide-down');
                        }
                        this.currentAnchor = index;
                        // 滚动条从头开始
                        content.scrollTo({top: 0});
                    }
                    else {
                        const content = entry.target;
                        content.classList.remove('slide-up');
                        content.classList.remove('slide-down');
                    }
                });
            };
            const observerContent = new IntersectionObserver(callbackContent, optionsContent);
            contents.forEach(content => {
                observerContent.observe(content);
            });
        }
    }
};
</script>

<style lang="less" scoped>
@screen-min-height: 500px;
@screen-max-height: 900px;

@content-min-width: 1300px;
@content-middle-width: 1440px;
@content-max-width: 1600px;
.cc-home {
    height: 100vh;
    min-height: @screen-min-height;
    min-width: 1240px;
    background-image: url('./assets/v2_banner_bg.png');
    background-repeat: repeat;
    background-color: linear-gradient(#D8EDFF, #FFFFFF);
}
.cc-top-container {
    height: 100%;
    width: 100%;
    overflow: hidden;
    margin: 0 auto;
    position: relative;
    .bg-video {
        margin: 0 auto;
        position: absolute;
        width: 100%;
        height: 100%;
        overflow: hidden;
        left: 50%;
        transform: translateX(-50%);
        .home-banner {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
        }
    }
    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
#cc-home-login-container {
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: 228px;
    z-index: 9;
    overflow: hidden;
    // transition: all 1s ease;
    transform: translateY(-50%);
    padding-bottom: calc(20vh - 10px);
    @media screen and (max-height: 600px) {
        padding-bottom: 0;
    }
}
.cc-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    position: fixed;
    top: 33px;
    width: 1200px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
    @media screen and (max-width: 1200px) {
        left: 0;
        transform: translateX(0);
        padding: 0 24px;
        width: 100vw;
    }
    @media screen and (min-width: @content-middle-width) and (max-width: @content-max-width) {
        width: 1300px;
    }
    @media screen and (min-width: @content-max-width) {
        width: 1400px;
    }
    &-left {
        img {
            height: 24px;
        }
    }
    &-right {
        display: flex;
        align-items: center;
        gap: 16px;
    }
    &-login {
        color: #fff;
        background: linear-gradient(270deg, #3434F4 0.3%, #4C79FF 99.35%);
        border-radius: 38px;
        padding: 9px 25px;
        font-weight: 500;
        font-size: 16px;
        border: none;
        &.login-passport {
            border: 1px solid #FFF;
            background: rgba(229, 238, 255, 0.50);
            /deep/ span {
                background: var(--AI-, linear-gradient(271deg, #3434F4 0.3%, #4C79FF 99.35%));
                background-clip: text;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }
        }
    }
    .header-line {
        height: 18px;
        width: 1px;
        opacity: 0.3;
        background: var(----G0, #FFF);
        background: linear-gradient(270deg, #3434F4 0.3%, #4C79FF 99.35%);
    }
}
.side-anchor {
    z-index: 4;
    position: fixed;
    right: 68px;
    top: 50%;
    transform: translateY(-50%);
    width: 14px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    .anchor-item {
        height: 14px;
        width: 14px;
        cursor: pointer;
        position: relative;
        .circle {
            width: 8px;
            height: 8px;
            border-radius: 4px;
            background-color: #fff;
        }
        .loop {
            border: 1px solid #fff;
            border-radius: 50%;
            height: 14px;
            left: -3px;
            position: absolute;
            top: -3px;
            width: 14px;
        }
    }
    @media screen and (max-width: @content-min-width) {
        right: 40px;
    }
}
.cc-sub-bg {
    height: 100vh;
    width: 100%;
    min-height: @screen-min-height;
    min-width: @screen-min-width;
    background-color: #fff;
    background-size: cover;
    background-image: url('./assets/navContentBgNew.png');
    background-position: top center;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    overflow: hidden;

    // 循环的背景块动画
    .random-block {
        background-image: url('https://qiaojiang.bj.bcebos.com/fe/static/images/home/content-cube-animation-new.webp');
        background-size: contain;
        background-repeat: no-repeat;
        position: absolute;
        right: 50%;
        top: 0;
        height: 70vh;
        width: 70vh;
        min-height: 400px;
        min-width: 400px;
        max-width: 600px;
        max-height: 600px;
        opacity: 0.5;
        transform: translateX(-25%) translateY(-60%) rotate(45deg);
        &.block1 {
            background-position: center bottom;
            height: 55vh;
            width: 55vh;
            max-height: 560px;
            max-height: 560px;
        }
        &.block2 {
            top: unset;
            left: unset;
            bottom: 0;
            left: 50%;
            opacity: 0.2;
            transform: translateX(30%) translateY(30%) rotate(45deg);
        }
    }
}
.cc-login-list {
    height: 100vh;
    width: 100%;
    min-height: @screen-min-height;
    overflow: scroll;
    &::-webkit-scrollbar {
        display: none;
    }

    scroll-snap-type: y mandatory;
    section {
        width: 100%;
        height: 100vh;
        min-height: @screen-min-height;
        /* 设置子元素的贴合对齐方式 start表示下一屏的内容会直接贴合到main元素的顶部*/
        scroll-snap-align: start;
    }
}
.cc-main-container {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    height: 100%;
    max-height: 100vh;

    @media screen and (min-width: @content-middle-width) and (max-width: @content-max-width) {
        width: 1300px;
    }
    @media screen and (min-width: @content-max-width) {
        width: 1400px;
    }
    .cc-main-content {
        // 与下方内容的文本+视频的宽度一致，然后居中。左侧自动留空
        width: calc(500px + 50%);
        margin: 0 auto;
        display: flex;
        height: 100%;
        flex-direction: column;
        justify-content: center;
        &-left {
            padding-top: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: auto;
            .main-logo {
                width: 250px;
                font-size: 23.5px;
                height: 58px;
                line-height: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 500;
                color: #fff;
                padding-top: 2px;
                border-radius: 70px 70px 70px 0px;
                background: linear-gradient(265.27deg, #5E5EFF 2.79%, #78BEFF 99.36%);
            }
            .main-title {
                margin-top: 20px;
                font-style: normal;
                font-weight: 400;
                font-size: 60px;
                line-height: 75px;
                color: #000000;
                &-line1 {
                    font-size: 82px;
                    line-height: 93px;
                }
                &-line2 {
                    font-size: 78px;
                    line-height: 93px;
                    margin-top: 2px;
                }
            }
            .main-desc {
                width: 550px;
                font-style: normal;
                font-weight: 300;
                font-size: 24px;
                line-height: 36px;
                color: #282C33;
                margin-top: 13px;
            }

            @media screen and (min-width: @content-max-width) {
                .main-title-line1 {
                    font-size: 82px;
                    line-height: 94px;
                }
                .main-title-line2 {
                    font-size: 78px;
                    line-height: 94px;
                }
                .main-logo {
                    font-size: 23.5px;
                    height: 58px;
                }
                .main-desc {
                    width: 550px;
                }
            }
            @media screen and (max-width: @content-min-width) {
                .main-title-line1 {
                    font-size: 62px;
                    line-height: 72px;
                }
                .main-title-line2 {
                    font-size: 58px;
                    line-height: 70px;
                }
                .main-logo {
                    font-size: 18px;
                    height: 43px;
                }
                .main-desc {
                    // width: 465px;
                    width: 560px;
                }
            }
            @media screen and (min-width: @content-min-width) and (max-width: @content-max-width) {
                .main-title-line1 {
                    // font-size: 69.7px;
                    // line-height: 80px;
                    font-size: 64px;
                    line-height: 74px;
                }
                .main-title-line2 {
                    // font-size: 66px;
                    // line-height: 76px;
                    font-size: 62px;
                    line-height: 72px;
                }
                .main-logo {
                    font-size: 20px;
                    height: 49px;
                }
                .main-desc {
                    // width: 465px;
                    width: 560px;
                }
            }
        }
    }
}
// 主题快捷导航
.cc-nav {
    &-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        max-height: 90px;
        height: auto;
        // backdrop-filter: blur(8.14286px);
        margin: 0 auto 0;
        margin-top: calc(20vh - 70px);
    }
    &-item-container {
        // flex: 1;
        display: flex;
        justify-content: center;

        &:last-child {
            border-right: none;
        }
    }
    &-item {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s ease;
        &:hover {
            // transform: translateY(-16px);
            // transform会导致hover动画抖动，改为padding
            padding-bottom: 30px;
        }
    }
    &-icon {
        width: 90px;
        height: 90px;
        background-size: 100% 100%;
        margin-right: 12px;
    }
    &-title {
        font-weight: 500;
        font-size: 24px;
        line-height: 34px;
        color: #282C33;
    }
    &-desc {
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #848B99;
        margin-top: 3px;
    }
}
@media screen and (max-width: @content-min-width) {
    .cc-nav-icon {
        width: 70px;
        height: 70px;
    }
    .cc-nav-title {
        font-size: 19px;
    }
    .cc-nav-desc {
        font-size: 15px;
    }
}
@media screen and (min-width: @content-min-width) and (max-width: @content-max-width) {
    .cc-nav-icon {
        width: 80px;
        height: 80px;
    }
    .cc-nav-title {
        font-size: 21px;
    }
    .cc-nav-desc {
        font-size: 15px;
    }
}
@media screen and (max-height: 600px) {
    .cc-nav-container {
        display: none;
    }
    .cc-main-container .cc-main-content {
        justify-content: center;
        .cc-main-content-left {
            padding-top: 0;
        }
    }
}
@media screen and (min-height: 600px) and (max-height: 700px) {
    .cc-nav-container {
        margin-top: calc(10vh - 10px);
        height: auto;
    }
}
.cc-sub-container {
    width: 100%;
    margin: 0 auto;
    background-color: transparent;
    background-size: cover;
    overflow: hidden;
    height: 100vh;
    min-height: @screen-min-height;
    position: relative;
    .cc-content {
        &-container {
            width: 1200px;
            margin: 0 auto;
            height: 100vh;
            min-height: @screen-min-height;
            margin-top: 100px;
            position: relative;
            display: flex;
            align-items: center;
            flex-direction: row;
            justify-content: center;
            &.right {
                flex-direction: row-reverse;
                .cc-nav-button.single {
                    background-image: none;
                    border: 1px solid #3A5BFD;
                }
            }
        }
        &-left,
        &-right {
            max-width: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        &-left {
            width: auto;
            justify-content: flex-end;
            padding-right: 65px;
        }
        &-right {
            width: 50%;
            justify-content: flex-start;
            padding-left: 65px;
            max-width: 700px;
            min-width: 400px;
        }
        &-text {
            width: 435px;
            min-width: 436px;
            align-items: flex-start;
            justify-content: flex-start;
            display: flex;
            flex-direction: column;
        }
        &-icon {
            height: 80px;
            width: 80px;
            position: relative;
            &-content {
                height: 100%;
                width: 100%;
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center center;
                position: absolute;
                top: 0;
                left: 0;
            }
        }
        &-title {
            margin-top: 20px;
            font-weight: 500;
            font-size: 78px;
            line-height: 109px;
            color: #0A0B0D;
        }
        &-desc {
            margin-top: 8px;
            font-weight: 400;
            font-size: 24px;
            line-height: 40px;
            color: #282C33;
        }
        &-button-list {
            display: flex;
        }
    }
    @media screen and (min-width: @content-middle-width) and (max-width: @content-max-width) {
        .cc-content-container {
            width: 1300px;
        }
    }
    @media screen and (min-width: @content-max-width) {
        .cc-content-container {
            width: 1400px;
        }
    }
    .cc-nav-button {
        min-width: 160px;
        height: 56px;
        font-size: 20px;
        border-radius: 47px;
        border: 1px #3A5BFD solid;
        font-weight: 500;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #3A5BFD;
        position: relative;

        border: 1px solid #3535F5;
        background-image: none;

        margin-right: 20px;
        margin-top: 72px;
        cursor: pointer;
        &.active:hover {
            // background-color: #ebf2ff;
            background-image: none;
            border: 1px solid #3535F5;
        }
        &.single {
            width: 160px;
            background-image: none;
            border: 1px solid #3535F5;
        }
        &.disabled {
            width: 160px;
            cursor: not-allowed;
            color: #A8B0BF;
            border: 1px solid #A8B0BF;
            background-image: unset;
            font {
                color: #A8B0BF;
            }
        }
        // 文字渐变
        font {
            background: linear-gradient(270.93deg, #3434F4 0.3%, #4C79FF 99.35%);
            color: transparent;
            -webkit-background-clip: text;
            margin: 0 19px;
        }
    }

    @media screen and (min-width: @content-max-width) {
        .cc-content-title {
            font-size: 78px;
            line-height: 109px;
            margin-top: 20px;
        }
        .cc-content-desc {
            font-size: 24px;
            line-height: 40px;
        }
        .cc-content-icon {
            width: 80px;
            height: 80px;
        }
        .cc-nav-button {
            margin-top: 32px;
            margin-bottom: 16px;
        }
    }
    @media screen and (max-width: @content-min-width) {
        .cc-content-title {
            font-size: 58px;
            line-height: 77px;
            margin-top: 12px;
        }
        .cc-content-desc {
            font-size: 18px;
            line-height: 30px;
        }
        .cc-content-icon {
            width: 60px;
            height: 60px;
        }
        .cc-nav-button {
            margin-top: 24px;
            margin-bottom: 18px;
        }
    }
    @media screen and (min-width: @content-min-width) and (max-width: @content-max-width) {
        .cc-content-title {
            font-size: 66px;
            line-height: 93px;
            margin-top: 13px;
        }
        .cc-content-desc {
            font-size: 20px;
            line-height: 34px;
        }
        .cc-content-icon {
            width: 68px;
            height: 68px;
        }
        .cc-nav-button {
            margin-top: 27px;
            margin-bottom: 18px;
        }
    }
    .cc-video-container {
        .cc-video {
            height: auto;
            max-width: 700px;
            min-width: 400px;
            width: 100%;
            border-radius: 36px;
            border-radius: 37px;
            box-shadow: 0px 4px 85px 0px #BAC6F636;
        }
    }
    &.has-footer {
        overflow-y: auto;
        overflow-x: hidden;
    }
    // 进入时添加一次性的滑动事件
    &.slide-up {
        .cc-content-container {
            margin-top: 0;
            animation: contentSlideUp 1s 1;
        }
    }
    // 向下拉动
    &.slide-down {
        .cc-content-container {
            margin-top: 0;
            // animation: contentSlideDown 1s 1;
        }
    }
    &.right {
        .random-block.block2 {
            right: 5%;
            bottom: -5%;
        }
    }
}
// 鼠标悬浮到图片上的切换效果，暂未使用
@keyframes playGif {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
// 内容区切换时的文本推入效果
@keyframes contentSlideUp {
    0% {
        margin-top: 200px;
    }
    100% {
        margin-top: 0;
    }
}
@keyframes contentSlideDown {
    0% {
        margin-top: -200px;
    }
    100% {
        margin-top: 0;
    }
}


.mouse-page-toggle {
    position: fixed;
    bottom: 30px;
    width: 50px;
    height: 54px;
    color: #848B99;
    font-size: 12px;
    line-height: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    left: 50%;
    margin-left: -25px;
    animation: moveUpDown .5s infinite alternate;
    img {
        width: 22px;
        height: 34px;
    }
}
@keyframes moveUpDown {
    0% {bottom: 30px;}
    to {bottom: 35px;}
}

.help-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    cursor: pointer;
    &:hover {
        color: #545B66;
    }
}
.help-overlay {
    /deep/ .veui-tooltip {
        border-radius: var(--Radius-r1, 6px);
        background: var(----G9, #282C33);
        margin-top: 6px;
        padding: 0 8px;
        height: 25px;
    }
    /deep/ .veui-tooltip-content {
        margin: 0px;
        color: var(----G0, #FFF);
        display: inline-flex;
        height: 100%;
        align-items: center;
    }
    /deep/ .veui-tooltip-arrow {
        color: var(----G9, #282C33);
    }
}
</style>
